import LabelLang from "component/LabelLang/label-lang";
import { API_BASE_URL } from "configs/AppConfig";
import { DEFAULTS } from "constants/Defaults";
import { DateFormater } from "functions/dateTimeFormat";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const NewsCardItem = ({
  title,
  // description,
  publicationDate,
  image,
  id,
  translations,
}) => {
  return (
    <div className="col-12 col-md-6 col-lg-4 pinned-card-item" key={id}>
      <Link to={`/mediaLanding/news/${id}`} className="item-bar">
        <img
          width={176}
          height={110}
          className="up"
          src={image ? `${API_BASE_URL}/${image}` : DEFAULTS.NEWS}
          alt="item-news"
          loading="lazy"
        />
        <div className="news-dateils w-100">
          <h5>
            <DateFormater value={publicationDate} />
          </h5>
          <h3>
            <div className="title">
              <LabelLang
                id="title"
                defaultValue={title}
                translations={translations}
              />
            </div>
          </h3>

          <div className="rev-item">
            <div className="more">
              <span>
                <FormattedMessage id="read-news" />
              </span>
              <i className="fas fa-ellipsis-h"></i>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default NewsCardItem;
